const buildUrl = ({to,subject,body}) => {
  if(!to ){
    return ''
  }
  return `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
}

export default buildUrl